import {FC, useState} from "react";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import {FormField} from "hooks/useForm";
import ShowPassword from "@mui/icons-material/Visibility";
import HidePassword from "@mui/icons-material/VisibilityOff";

export const validatePassword = (value: string) =>
  value.length === 0 ? "Password is required" : undefined;

const PasswordInput: FC<FormField<string>> = ({onChange, error, value}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      label="Password"
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={e => onChange(e.target.value)}
      error={!!error}
      helperText={error}
      fullWidth
      margin="normal"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(prev => !prev)}
                edge="end"
                aria-label={showPassword ? "Hide password" : "Show password"}>
                {showPassword ? <HidePassword /> : <ShowPassword />}
              </IconButton>
            </InputAdornment>
          ),
        },
        formHelperText: {sx: {marginLeft: 0}},
      }}
    />
  );
};

export default PasswordInput;
